import { CopyOutlined, LinkOutlined, SearchOutlined } from '@ant-design/icons'
import { Button, Row, Space, Table, message, Input } from 'antd'
import { useMemo, useState } from 'react'
import { useParams } from 'react-router-dom'
import { PageHeader } from '~/components/PageHeader'
import SecureFormPostActionButton from '~/components/SecureFormPostActionButton'
import { useTableDataSourceKey } from '~/hooks/useTableDataSourceKey'
import { backendUrl, clipboard, compareText } from '~/utils/helpers'
import { useParticipantsQuery } from './query'

const columns = () => [
  {
    title: 'Alias',
    render: (student) => student?.alias
  },
  {
    title: 'Name',
    render: (student) => `${student?.first_name} ${student?.last_name}`,
    sorter: (a, b) =>
      compareText(
        `${a.first_name} ${a.last_name}`,
        `${b.first_name} ${b.last_name}`
      )
  },
  {
    title: 'Username',
    render: (student) => student?.username
  },
  {
    title: 'Password',
    render: (student) => (
      <Space size='small'>
        <span>{student?.password}</span>
        <Button
          icon={<CopyOutlined />}
          onClick={() => {
            clipboard(student?.password)
            message.success('Copied')
          }}
        />
      </Space>
    )
  },
  {
    title: 'Email',
    render: (student) => student?.email,
    sorter: (a, b) => compareText(a.email, b.email)
  },
  {
    title: 'Connected Server',
    render: (student) => student?.server?.name
  },
  {
    title: 'Action',
    render: (item) => {
      if (item.enabled === false) {
        return null
      }
      return (
        <Space size='middle'>
          <Button
            key={1}
            type='primary'
            icon={<CopyOutlined />}
            onClick={() => {
              clipboard(
                `${window.location.origin}/workstation-info/${item?.appstream_token}`
              )
              message.success('Copied')
            }}
          >
            Copy link
          </Button>
          <a
            key={2}
            href={item.workstation_link}
            target='_blank'
            style={{ color: 'white', marginLeft: 5 }}
            rel='noreferrer'
          >
            <Button type='primary' icon={<LinkOutlined />}>
              Open workstation
            </Button>
          </a>
        </Space>
      )
    }
  }
]

const DoctorCourseStudents = () => {
  const { id } = useParams()
  const { data, isLoading } = useParticipantsQuery(id)
  const dataSource = useTableDataSourceKey(data)
  const [filterInput, setFilterInput] = useState('')

  const filterData = useMemo(() => {
    const filter = filterInput.toLowerCase()
    if (!dataSource) {
      return []
    }

    return dataSource
      .filter((student) => student.enabled !== false)
      .filter(
        (student) =>
          `${student.first_name} ${student.last_name}`
            .toLowerCase()
            .includes(filter) || student.email.toLowerCase().includes(filter)
      )
  }, [dataSource, filterInput])

  const activeWorkstationCount = useMemo(() => {
    if (!Array.isArray(dataSource)) {
      return 0
    }

    return dataSource.filter((student) => student.enabled).length
  }, [dataSource])

  return (
    <>
      <PageHeader
        className='radup-page-header'
        extra={[
          <Input.Search
            key={1}
            placeholder='Search'
            allowClear
            enterButton={<SearchOutlined />}
            onSearch={setFilterInput}
          />,
          <SecureFormPostActionButton
            key='download'
            actionUrl={backendUrl(
              `statistic/courses/${id}/export-doctor-registrations`
            )}
            title='Download registrations'
          />
        ]}
      />

      <Table
        size='small'
        tableLayout='auto'
        dataSource={filterData}
        columns={columns()}
        loading={isLoading}
        // rowClassName={(record) => (record.enabled ? '' : 'disabled-row')}
        footer={() => (
          <Row justify='start'>
            <span>Total: {activeWorkstationCount} workstations</span>
          </Row>
        )}
      />
    </>
  )
}

DoctorCourseStudents.propTypes = {}

DoctorCourseStudents.defauldProps = {}

export default DoctorCourseStudents
